module.exports = "/images/empty_data_icon.png?c9f4624bc607d0078ab686c29d2b7c37";